export default __webpack_public_path__ + "static/imda20192ndprize2-f59d62f358e828c52b376518a639425a.jpg";